// frontend/admin-portal/src/contexts/ProductsContext.jsx
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { productService } from "../services/productService";

const ProductsContext = createContext(null);

export function ProductsProvider({ children }) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const inFlight = useRef(false);

  const refresh = useCallback(async () => {
    // Prevent overlapping fetches (e.g. rapid route changes)
    if (inFlight.current) return;
    inFlight.current = true;
    setLoading(true);
    try {
      // Ask for a cheap 1-item page to read `pagination.total`
      const { pagination } = await productService.list({ page: 1, limit: 1 });
      setCount(pagination?.total ?? 0);
    } catch {
      // Silent — badge just won't update. Don't break the UI over a counter.
    } finally {
      setLoading(false);
      inFlight.current = false;
    }
  }, []);

  // Initial load
  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = { count, loading, refresh };

  return (
    <ProductsContext.Provider value={value}>
      {children}
    </ProductsContext.Provider>
  );
}

export const useProducts = () => {
  const ctx = useContext(ProductsContext);
  if (!ctx) throw new Error("useProducts must be used within ProductsProvider");
  return ctx;
};
